import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { ToolbarHeaderComponent } from './toolbar-header.component';

@NgModule({
  declarations: [ToolbarHeaderComponent],
  imports: [CommonModule, IonicModule, TranslateModule],
  exports: [ToolbarHeaderComponent],
})
export class ToolbarHeaderModule {}
